'use client'

import { Countdown } from '@fukku/countdown/Countdown'
import styles from './HeroBannerPromoCountdown.module.css'

export const HeroBannerPromoCountdown = ({
	date,
}: {
	readonly date: string
}) => (
	<Countdown
		date={date}
		className={styles.text}
		numbersClassName={styles.numbers}
	/>
)
